const tr = {
    Customers: {
        name: "Müşteri İsmi",
        namePlaceholder: "Müşteri İsmini Giriniz",
        countryLabel: "Ülke",
        countryPlaceholder: "Ülke Seçiniz",
        identityLabel: "Vergi No / Kimlik No",
        identityPlaceholder: "Vergi No / Kimlik No Giriniz",
        taxLabel: "Vergi Dairesi",
        taxPlaceholder: "Vergi Dairesi Giriniz",
    },
    Competitors: {
        companyLabel: "Competitor Company Name",
        companyPlaceholder: "Competitor Company",
    },
    Errors: {
        required: "alanı zorunludur.",
    },
};

export default tr;